<template>
  <div>
    Танцоры
  </div>
</template>

<script>
  export default {
    name: "Dancers"
  }
</script>

<style scoped>

</style>
